/** Canonical App Store listing (US). */
export const APP_STORE_URL =
  'https://apps.apple.com/us/app/mintcheck/id6759132070';

/** Black Apple logo (SVG). On primary/green buttons use `brightness-0 invert` (Tailwind) or equivalent CSS. */
export const APPLE_LOGO_SVG_URL =
  'https://iawkgqbrxoctatfrjpli.supabase.co/storage/v1/object/public/assets/3P-content/logos/Apple_logo_black.svg';
